import React from 'react';

import PromoCodeTableRow from './PromoCodeTableRow';

import './PromoCodeTable.scss';

class PromoCodeTable extends React.Component {
  _onPromoCodeChange(ident) {
    return value => {
      this.props.onValueChange(ident, value);
    };
  }

  render() {
    const {
      promoCodeRows,
      inputId,
      editMode
    } = this.props;

    return (
      <table className="parkchirp--promo-code-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Allowed Uses</th>
            <th>Current Uses</th>
            <th>Expires On</th>
          </tr>
        </thead>
        <tbody>
          {promoCodeRows.map(promoCodeRow => {
            return (
              <PromoCodeTableRow inputId={inputId}
                key={promoCodeRow.ident}
                ident={promoCodeRow.ident}
                promoCode={promoCodeRow.data}
                onValueChange={this._onPromoCodeChange(promoCodeRow.ident)}
                editMode={editMode}
              />
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default PromoCodeTable;
